import { render, staticRenderFns } from "./afiliaciones.vue?vue&type=template&id=5c3984f8"
import script from "./afiliaciones.vue?vue&type=script&lang=js"
export * from "./afiliaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports